// src/config/subscriptionPlans.ts

// Añadimos 'professional' a los tipos permitidos
export const SUBSCRIPTION_TIERS = ['free', 'standard', 'professional', 'premium', 'admin'] as const;
export type SubscriptionTier = typeof SUBSCRIPTION_TIERS[number];

export const PAID_SUBSCRIPTION_TIERS = ['standard', 'professional', 'premium'] as const;

export interface SubscriptionPlan {
  name: string;
  maxMessages: number;
  price: number;
  features: string[];
}

const SUBSCRIPTION_TIER_SET = new Set<string>(SUBSCRIPTION_TIERS);
const PAID_SUBSCRIPTION_TIER_SET = new Set<string>(PAID_SUBSCRIPTION_TIERS);

export const isSubscriptionTier = (value: unknown): value is SubscriptionTier => {
  return typeof value === 'string' && SUBSCRIPTION_TIER_SET.has(value);
};

export const isPaidSubscriptionTier = (value: unknown): value is (typeof PAID_SUBSCRIPTION_TIERS)[number] => {
  return typeof value === 'string' && PAID_SUBSCRIPTION_TIER_SET.has(value);
};

export const SUBSCRIPTION_PLANS = {
  free: {
    name: 'Plan Prueba', // Antes Básico
    maxMessages: 5, // Solo para probar que funciona
    price: 0,
    features: ['Consultas y diligencias', 'Adjuntos y plantillas privadas', 'Razonamiento Normal'],
  },
  standard: {
    name: 'Plan Básico', // Nuevo plan de entrada de pago
    maxMessages: 30, // Suficiente para uso muy ocasional
    price: 1.00,
    features: ['Consultas y diligencias', 'Adjuntos y plantillas privadas', 'Razonamiento Normal'],
  },
  professional: {
    name: 'Plan Profesional', // El nuevo plan intermedio
    maxMessages: 150, // Uso regular
    price: 4.99,
    features: ['Consultas y diligencias', 'Adjuntos y plantillas privadas', 'Razonamiento Normal y Alto'],
  },
  premium: {
    name: 'Plan Premium',
    maxMessages: 300, // Uso intensivo
    price: 9.99,
    features: ['Consultas y diligencias', 'Adjuntos y plantillas privadas', 'Razonamiento Normal, Alto y Máximo'],
  },
  admin: {
    name: 'Administrador',
    maxMessages: 999999, // Sin límites
    price: 0,
    features: ['Control total del sistema']
  }
} satisfies Record<SubscriptionTier, SubscriptionPlan>;

// 30 días en milisegundos para calcular la renovación del ciclo
export const MILLISECONDS_IN_MONTH = 30 * 24 * 60 * 60 * 1000;
